import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';
import LoadingSpinner from './LoadingSpinner.js';
import type { UserRole } from '../../shared/types.js';

interface Props {
  requiredRoles?: UserRole[];
}

export default function ProtectedRoute({ requiredRoles }: Props) {
  const { user, loading, initialized } = useAuth();

  if (!initialized || loading) {
    return <LoadingSpinner message="Authentifizierung wird geprüft..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && !requiredRoles.includes(user.role)) {
    return <Navigate to="/scan" replace />;
  }

  return <Outlet />;
}
